import { render, staticRenderFns } from "./Create-Contact-Person.vue?vue&type=template&id=0db7bffa"
import script from "./Create-Contact-Person.vue?vue&type=script&lang=js"
export * from "./Create-Contact-Person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports